module.exports = __webpack_public_path__ + "static/liane_xu-8a0561fb810c7d3ddb8000b27ab4656f.jpg";